module.exports = __webpack_public_path__ + "img/w3_trash_recover_black.9705ad47.png";